import './css/MenuTemplate.css'

import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { Button, Form, Input, message, Select, Space, Table } from "antd"
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import _ from "lodash"

const { Option } = Select
const { Column } = Table

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 }
}

const tailLayout = {
    wrapperCol: { offset: 4, span: 16 }
}

type project = {
    id: string
    item_name: string
}

// 界面渲染使用的格式
type stepDataType = {
    stage_number: number | undefined,
    stage_desc: string | undefined,
    high_price_item_count: number,
    detail: {
        which_day: number,
        food_row: {
            meal_times: number,
            menu_item_list: {
                menu_item_name: string | undefined,
                menu_item_id: string | undefined,
                menu_item_count: number
                is_high_price: number
            }[]
        }[]
    }[]
}[]

// 后端接收的格式
type backendStepDataType = {
    stage_number: number | undefined,
    stage_desc: string | undefined,
    high_price_item_count: number,
    detail: {
        which_day: number,
        meal_times: number,
        menu_item_list: {
            menu_item_name: string | undefined,
            menu_item_id: string | undefined,
            menu_item_count: number
        }[]
    }[]
}[]

export default function () {

    const params: { id: string } = useParams()
    const [title, setTitle] = useState<string>('')

    const [form] = Form.useForm()
    const [templateId, setTemplateId] = useState<string>()

    // 当前阶段
    const [currentStep, setCurrentStep] = useState<number>(0)
    // 当前天数
    const [currentDay, setCurrentDay] = useState<number>(0)

    const [itemList, setItemList] = useState<project[]>([])
    const [foodTypeList, setFoodTypeList] = useState<{ menu_type_id: string, menu_type_name: string }[]>([])
    const [foodList, setFoodList] = useState<{ menu_item_id: string, menu_item_name: string, is_high_price: number }[]>([])
    const [menu, setMenu] = useState<{ menu_item_id: string, menu_item_name: string, is_high_price: number }>()

    // 一天的餐次模板
    const foodRowTmp = [
        {
            meal_times: 1,
            menu_item_list: []
        },
        {
            meal_times: 2,
            menu_item_list: []
        },
        {
            meal_times: 3,
            menu_item_list: []
        },
        {
            meal_times: 4,
            menu_item_list: []
        },
        {
            meal_times: 5,
            menu_item_list: []
        },
        {
            meal_times: 6,
            menu_item_list: []
        }
    ]
    // 阶段模板
    const tempStepData = {
        // 阶段、阶段描述、高价菜品数量
        stage_number: 0, stage_desc: undefined, high_price_item_count: 0,
        // 每天的餐次数据
        detail: [
            {
                which_day: 1, food_row: _.cloneDeep(foodRowTmp)
            }
        ]
    }

    const [stepData, setStepData] = useState<stepDataType>([
        {
            stage_number: 1, stage_desc: undefined, high_price_item_count: 0,
            detail: [
                {
                    which_day: 1, food_row: _.cloneDeep(foodRowTmp)
                }
            ]
        }
    ])
    const [stepBackendData, setStepBackendData] = useState<backendStepDataType>([])

    useEffect(() => {
        // 查询月子套餐
        baseAxiosNoInfo('/global/item_list', { params: { item_type: 3 } }).then((res: any) => {
            res && setItemList(res)
        })

        // 查询菜品分类列表
        baseAxiosNoInfo('/cooking_center/global/menu_type_list').then((res: any) => {
            res && setFoodTypeList(res)
        })

        // 若是编辑功能
        if (params.id) {
            baseAxiosNoInfo('/cooking_center/menu_template/detail', { params: { template_id: params.id } }).then((res: any) => {
                setTemplateId(res.template_id)

                form.setFieldsValue({
                    template_name: res.template_name,
                    belong_store_id: res.belong_store_id.split(','),
                    belong_item_id: res.belong_item_id.split(','),
                })

                // 转换后端响应的数据
                let stage = res.stage
                let newStepData: stepDataType = []

                for (let i = 0; i < stage.length; i++) {
                    let detailArr: any = []
                    let detail = stage[i].detail

                    for (let j = 0; j < detail.length; j++) {
                        // 若不存在
                        if (!detailArr.some((el: any) => el.which_day === detail[j].which_day)) {
                            let foodRow: any = _.cloneDeep(foodRowTmp)

                            foodRow.forEach((foodEl: any) => {
                                if (foodEl.meal_times === detail[j].meal_times) {
                                    foodEl.menu_item_list = detail[j].menu_item_list
                                }
                            })

                            detailArr.push({
                                which_day: detail[j].which_day,
                                food_row: foodRow
                            })

                        } else {
                            // 若已存在天数和餐次，则追加该天数具体餐次的菜品
                            let currentDetailArrRow = detailArr.filter((el: any) => el.which_day === detail[j].which_day)[0]
                            let currentDetailArrFoodRow = currentDetailArrRow.food_row

                            currentDetailArrFoodRow.forEach((el: any) => {
                                if (el.meal_times === detail[j].meal_times) {
                                    el.menu_item_list.push(...detail[j].menu_item_list)
                                }
                            })
                        }
                    }

                    newStepData.push({
                        stage_number: stage[i].stage_number, stage_desc: stage[i].stage_desc, high_price_item_count: stage[i].high_price_item_count,
                        detail: detailArr
                    })
                }

                setStepData(newStepData)
            })

            setTitle('编辑标准餐单')

        } else {
            setTitle('新增标准餐单')
        }
    }, [])

    const syncHighNum = (d: any) => {
        // 同步高价菜品数量
        d.forEach((el: any, index: number) => {
            let highNum = 0

            el.detail.forEach((el2: any, index2: number) => {
                el2.food_row.forEach((el3: any, index3: number) => {
                    el3.menu_item_list.forEach((el4: any, index4: number) => {
                        if (el4.is_high_price === 1 && el4.menu_item_count > 0) {
                            highNum += el4.menu_item_count
                        }
                    })
                })
            })

            el.high_price_item_count = highNum
        })
    }

    let getItemList = itemList.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

    return <div className="common-level2-edit h-detail">
        {/* 膳食中心 -> 营养膳食 -> 标准餐单管理 -> 新增或编辑 */}
        <p className="modules-h2">{title}</p>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
        </div>

        <div className="standard-food-detail">
            <p style={{ marginLeft: 20, fontSize: 20 }}>所有带<span style={{ color: 'red' }}>*</span>号为必填项</p>

            <Form {...layout} form={form}>
                <Form.Item name="template_name" label="餐单名称" required>
                    <Input />
                </Form.Item>

                <Form.Item name="belong_store_id" label="适用门店" required>
                    <SelectStores showSearch multiple width={600} />
                </Form.Item>

                <Form.Item name="belong_item_id" label="适用套餐" required>
                    <Select showSearch className="fl" virtual={false} mode="multiple" style={{ width: 600, marginRight: 12, marginBottom: 12 }} placeholder="套餐"
                        filterOption={(input, option) =>
                            (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {getItemList}
                    </Select>
                </Form.Item>
            </Form>

            <Form {...layout}  >
                <Form.Item label="阶段" >
                    <div className="sf-tab-btns clear" >
                        {stepData.map((el, index: number) => <div className={index === currentStep ? 'current' : ''} onClick={() => {
                            setCurrentStep(index)
                            setCurrentDay(0)
                        }}>第{index + 1}阶段</div>)}

                        {stepData.length > 1 && <div title="只能删除最后1阶段" className="add" onClick={() => {
                            setCurrentStep(0)

                            let d = _.cloneDeep(stepData)
                            d.pop()

                            setStepData(d)
                        }}><DeleteOutlined /></div>}

                        <div className="add" onClick={() => {
                            let d = _.cloneDeep(stepData)
                            let tmp = _.cloneDeep(tempStepData)

                            tmp.stage_number = stepData.length + 1
                            d.push(tmp)

                            setStepData(d)
                        }}>添加阶段</div>
                    </div>
                </Form.Item>
            </Form>

            {stepData.map((step, stepIndex) => <div style={{ display: stepIndex === currentStep ? 'block' : 'none' }}>
                <Form {...layout}  >
                    <Form.Item label="阶段描述" required>
                        <Input style={{ width: '300px' }} value={step.stage_desc} onChange={(e: any) => {
                            let d = _.cloneDeep(stepData)
                            d[stepIndex].stage_desc = e.target.value

                            setStepData(d)
                        }} />
                    </Form.Item>

                    <Form.Item label="阶段高价菜品的数量" >
                        <Input disabled value={stepData[stepIndex].high_price_item_count} style={{ width: '300px' }} />
                    </Form.Item>

                    <Form.Item label="添加菜品" >
                        <Space style={{ marginBottom: 14 }}>
                            {step.detail.map((stepDetailEl, detaiIndex: number) => <Button className={detaiIndex === currentDay ? 'sfday-tab-btns current' : 'sfday-tab-btns'} onClick={() => {
                                setCurrentDay(detaiIndex)
                            }}>第{detaiIndex + 1}天</Button>)}

                            {step.detail.length > 1 && <Button title="只能删除最后1天" onClick={() => {
                                let d = _.cloneDeep(stepData)
                                d[currentStep].detail.pop()

                                setStepData(d)
                                setCurrentDay(0)
                            }}><DeleteOutlined /></Button>}

                            <Button className="sfday-tab-btns add" onClick={() => {
                                let d = _.cloneDeep(stepData)
                                d[stepIndex].detail.push({
                                    which_day: step.detail.length + 1, food_row: _.cloneDeep(foodRowTmp)
                                })

                                setStepData(d)
                            }}>添加1天</Button>
                        </Space>

                        {step.detail.map((dayDetailRow, dayDetailIndex) => <Table style={{ display: dayDetailIndex === currentDay ? 'block' : 'none' }} bordered dataSource={dayDetailRow.food_row} pagination={false}>
                            <Column title="餐次" render={(v: any) => {
                                switch (v.meal_times) {
                                    case 1:
                                        return '早餐（8:00）'
                                    case 2:
                                        return '加餐（10:00）'
                                    case 3:
                                        return '午餐（12:00）'
                                    case 4:
                                        return '间餐（15:00）'
                                    case 5:
                                        return '晚餐（18:00）'
                                    case 6:
                                        return '宵夜（20:00）'
                                }
                            }}></Column>

                            <Column title={"具体菜品"} render={(v: any) => {
                                return <div>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        <div style={{ marginBottom: 14 }}>
                                            <Select showSearch allowClear
                                                virtual={false} style={{ maxWidth: 140, marginRight: 14 }} placeholder="选择菜品分类"
                                                onChange={(v: string) => {
                                                    // 查询该分类下的菜品
                                                    baseAxiosNoInfo('/cooking_center/global/menu_item_list_by_type_id', {
                                                        params: {
                                                            menu_type_id: v
                                                        }
                                                    }).then((res: any) => {
                                                        res && setFoodList(res)
                                                    })
                                                }}
                                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                            >
                                                {foodTypeList.map(el => <Option value={el.menu_type_id}>{el.menu_type_name}</Option>)}
                                            </Select>

                                            <Select showSearch allowClear
                                                virtual={false} style={{ maxWidth: 140 }} placeholder="选择菜品"
                                                onChange={(v: any) => {
                                                    setMenu(foodList.find(el => el.menu_item_id === v))
                                                }}
                                                onSearch={
                                                    (v: any) => {
                                                        setMenu(foodList.find(el => el.menu_item_id === v))
                                                    }
                                                }
                                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                            >
                                                {foodList.map(el => <Option value={el.menu_item_id}>{el.menu_item_name}</Option>)}
                                            </Select>
                                        </div>

                                        {dayDetailRow.food_row[v.meal_times - 1].menu_item_list.map((mealRow, mealRowIndex) => <li style={{ marginBottom: 10 }}>
                                            <Space>
                                                {mealRow.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}
                                                <span>{mealRow.menu_item_name}</span>

                                                <Input style={{ width: 60 }} size="small" value={mealRow.menu_item_count} onChange={(e: any) => {
                                                    let num = Number(e.target.value)

                                                    if (!isNaN(num)) {
                                                        let d = _.cloneDeep(stepData)
                                                        d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list[mealRowIndex].menu_item_count = num

                                                        // 同步高价菜品数量
                                                        syncHighNum(d)
                                                        setStepData(d)

                                                    } else {
                                                        message.error('必须填写数字')
                                                    }
                                                }} />

                                                <DeleteOutlined style={{ cursor: 'pointer' }} onClick={() => {
                                                    let d = _.cloneDeep(stepData)
                                                    d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list.splice(mealRowIndex, 1)

                                                    // 同步高价菜品数量
                                                    syncHighNum(d)
                                                    setStepData(d)
                                                }} />
                                            </Space>
                                        </li>)}
                                    </ul>

                                    <Space style={{ marginTop: 8 }}>
                                        <Button size="small" onClick={() => {
                                            if (menu) {
                                                let d = _.cloneDeep(stepData)

                                                if ((d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list).some(el => el.menu_item_id === menu.menu_item_id)) {
                                                    message.error('菜品已存在该餐次当中')
                                                    return
                                                }

                                                d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list.push({
                                                    menu_item_name: menu?.menu_item_name,
                                                    menu_item_id: menu?.menu_item_id,
                                                    menu_item_count: 0,
                                                    is_high_price: menu.is_high_price
                                                })

                                                setStepData(d)

                                            } else {
                                                message.error('必须先选择菜品分类和菜品')
                                            }
                                        }}>添加菜品</Button>

                                        <Button size="small" onClick={() => {
                                            let d = _.cloneDeep(stepData)
                                            d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list = []

                                            // 同步高价菜品数量
                                            syncHighNum(d)
                                            setStepData(d)
                                        }}>清空</Button>
                                    </Space>
                                </div>
                            }}></Column>
                        </Table>)}
                    </Form.Item>
                </Form>
            </div>)}

            <Form {...layout}  >
                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit" onClick={() => {
                        // 将数据格式转换为后端所需
                        function stepDataFormatToBackEnd(data: stepDataType): backendStepDataType {
                            let result: backendStepDataType = []

                            for (let i = 0; i < data.length; i++) { // 阶段
                                let detailArr: any = []

                                for (let j = 0; j < data[i].detail.length; j++) { // 每天餐次
                                    let frs: any = data[i].detail[j].food_row
                                    let isAllEmpty = frs.every((elt: any) => elt.menu_item_list.length === 0)

                                    if (isAllEmpty) {
                                        message.error('每天至少一个餐次中存在一个菜品，否则不能提交。')
                                        return []
                                    }

                                    for (let k = 0; k < frs.length; k++) {
                                        if (frs[k].menu_item_list.length > 0) {
                                            detailArr.push({
                                                which_day: data[i].detail[j].which_day,
                                                meal_times: frs[k].meal_times,
                                                menu_item_list: frs[k].menu_item_list
                                            })

                                            if (frs[k].menu_item_list.every((el5: any) => el5.menu_item_count <= 0)) {
                                                message.error('单菜品的数量必须大于0，否则不能提交。')
                                                return []
                                            }
                                        }
                                    }
                                }

                                result.push({
                                    stage_number: data[i].stage_number,
                                    stage_desc: data[i].stage_desc,
                                    high_price_item_count: data[i].high_price_item_count,
                                    detail: detailArr
                                })
                            }

                            return result
                        }

                        if (params.id) {
                            baseAxiosComplete.post('/cooking_center/menu_template/update', {
                                template_id: templateId,
                                template_name: form.getFieldValue('template_name'),
                                belong_store_id: form.getFieldValue('belong_store_id') ? form.getFieldValue('belong_store_id').join(',') : undefined,
                                belong_item_id: form.getFieldValue('belong_item_id') ? form.getFieldValue('belong_item_id').join(',') : undefined,
                                stage: stepDataFormatToBackEnd(stepData)
                            }).then((res: any) => {
                                if (res.status === 0) {
                                    window.history.go(-1)
                                }
                            })

                        } else {
                            baseAxiosComplete.post('/cooking_center/menu_template/add', {
                                template_name: form.getFieldValue('template_name'),
                                belong_store_id: form.getFieldValue('belong_store_id') ? form.getFieldValue('belong_store_id').join(',') : undefined,
                                belong_item_id: form.getFieldValue('belong_item_id') ? form.getFieldValue('belong_item_id').join(',') : undefined,
                                stage: stepDataFormatToBackEnd(stepData)
                            }).then((res: any) => {
                                if (res.status === 0) {
                                    window.history.go(-1)
                                }
                            })
                        }
                    }}>
                        提交
                    </Button>
                </Form.Item>
            </Form>
        </div>
    </div>
}